import { useQuery, type ApolloError } from '@apollo/client';
import type { RetainersForMatterQuery } from '~/gql/graphql';
import { RetainersForMatterDocument } from '~/graphql/queries/retainersForMatter';

export interface UseRetainersForMatterResult {
  retainers: RetainersForMatterQuery['retainersForMatter'];
  isLoading: boolean;
  error: ApolloError | undefined;
  refetch: () => Promise<unknown>;
}

/**
 * Retainers visible to the current user for a matter (backend-scoped).
 * Use `skip` via absent `matterId` when the route has no id yet.
 */
export function useRetainersForMatter(
  matterId: string | undefined,
): UseRetainersForMatterResult {
  const { data, loading, error, refetch } = useQuery<RetainersForMatterQuery>(
    RetainersForMatterDocument,
    {
      variables: { matterId: matterId! },
      skip: !matterId,
      fetchPolicy: 'cache-first',
    },
  );

  return {
    retainers: data?.retainersForMatter ?? [],
    isLoading: loading,
    error,
    refetch,
  };
}
